import React from 'react'
import Reports from '../Reports'

export default function ClientDashboardV3ReportsBridge() {
  return <Reports />
}

